import PropTypes from "prop-types"
import React from "react"
import { Tooltip } from "react-tooltip"

const HealMeTooltip = ({ style, ...props }) => (
  <Tooltip
    style={{
      "--rt-color-dark": "rgb(var(--color-black))",
      zIndex: "9999",
      fontWeight: "bold",
      maxWidth: "18rem",
      borderRadius: "0.375rem",
      padding: "4px",
      ...style
    }}
    {...props}
  />
)

HealMeTooltip.propTypes = {
  id: PropTypes.string,
  anchorSelect: PropTypes.string,
  render: PropTypes.func,
  place: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  noArrow: PropTypes.bool,
  isOpen: PropTypes.bool,
  style: PropTypes.object
}

export default HealMeTooltip
